import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getRoadtrips } from '../services/api';
import './Home.css';

const Home = () => {
  const { user } = useAuth();
  const [roadtrips, setRoadtrips] = useState({ done: [], upcoming: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRoadtrips = async () => {
      try {
        const response = await getRoadtrips();
        if (response.success) {
          // Utiliser directement les données triées du serveur
          setRoadtrips({
            done: response.data.done || [],
            upcoming: response.data.upcoming || []
          });
        } else {
          setError(response.message || 'Erreur lors du chargement des données');
        }
      } catch (err) {
        console.error('Erreur fetchRoadtrips:', err);
        setError('Erreur de connexion au serveur');
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      fetchRoadtrips();
    } else {
      setLoading(false);
    }
  }, [user]);

  if (loading) return <div className="alert alert-info">Chargement...</div>;
  if (error) return <div className="alert alert-danger">{error}</div>;

  // Prendre les 3 derniers roadtrips terminés
  const recentDone = roadtrips.done
    .filter(rt => rt.roadtrip_status === "1")
    .slice(0, 3);

  // Prendre les 3 prochains roadtrips
  const nextUpcoming = roadtrips.upcoming.slice(0, 3);

  if (!user) {
    return (
      <div className="home-container">
        <div className="welcome-section">
          <h1>Bienvenue sur Roadtrips</h1>
          <p>Planifiez et partagez vos aventures routières</p>
          <div className="auth-buttons">
            <Link to="/login" className="btn btn-primary">Se connecter</Link>
            <Link to="/login" className="btn btn-outline-primary">S'inscrire</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="home-container">
      <section className="welcome-section">
        <h1>Bienvenue sur RoadTrip</h1>
        <p>Planifiez et gardez une trace de tous vos voyages</p>
        <Link to="/new-roadtrip" className="btn btn-primary">
          Créer un nouveau roadtrip
        </Link>
      </section>

      <section className="recent-trips">
        <div className="section-header">
          <h2>Derniers roadtrips terminés</h2>
          <Link to="/roadtrips" className="view-all">Voir tous</Link>
        </div>
        <div className="trips-grid">
          {recentDone.length > 0 ? (
            recentDone.map(roadtrip => (
              <div key={roadtrip.roadtrip_id} className="trip-card">
                <h3>{roadtrip.roadtrip_name}</h3>
                {roadtrip.date_depart_prevu && roadtrip.date_depart_prevu !== '0000-00-00' && (
                  <div className="dates">
                    {new Date(roadtrip.date_depart_prevu).toLocaleDateString()} 
                    - 
                    {new Date(roadtrip.date_fin_prevu).toLocaleDateString()}
                  </div>
                )}
                {roadtrip.description && (
                  <p className="description">{roadtrip.description}</p>
                )}
                <Link 
                  to={`/roadtrip/${roadtrip.roadtrip_id}`}
                  className="btn btn-outline-primary btn-sm"
                >
                  Voir le détail
                </Link>
              </div>
            ))
          ) : (
            <p className="no-trips">Aucun roadtrip terminé</p>
          )}
        </div>
      </section>

      <section className="upcoming-trips">
        <div className="section-header">
          <h2>Prochains roadtrips</h2>
          <Link to="/roadtrips" className="view-all">Voir tous</Link>
        </div>
        <div className="trips-grid">
          {nextUpcoming.length > 0 ? (
            nextUpcoming.map(roadtrip => (
              <div key={roadtrip.roadtrip_id} className="trip-card upcoming">
                <h3>{roadtrip.roadtrip_name}</h3>
                {roadtrip.date_depart_prevu && roadtrip.date_depart_prevu !== '0000-00-00' && (
                  <div className="dates">
                    {new Date(roadtrip.date_depart_prevu).toLocaleDateString()} 
                    - 
                    {new Date(roadtrip.date_fin_prevu).toLocaleDateString()}
                  </div>
                )}
                {roadtrip.description && (
                  <p className="description">{roadtrip.description}</p>
                )}
                {roadtrip.lieux && (
                  <div className="locations">
                    <strong>Lieux :</strong>
                    <p>{roadtrip.lieux}</p>
                  </div>
                )}
                <Link 
                  to={`/roadtrip/${roadtrip.roadtrip_id}`}
                  className="btn btn-outline-success btn-sm"
                >
                  Voir le détail
                </Link>
              </div>
            ))
          ) : (
            <p className="no-trips">Aucun roadtrip prévu</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default Home; 